// extracted by mini-css-extract-plugin
export default {"modal":"PP-z","error":"QP-z","disabled":"RP-z","fields":"SP-z","errorMsg":"TP-z","footer":"UP-z","formContentWrapper":"VP-z","productImage":"WP-z","overlay":"XP-z"};